<template>
    <div class="lms__superadmin_customer_service_sso_edit_mel_setup">
        <component-wrapper>
            <component-title :margin="'large'" :size="'large'">{{ isAddMode ? 'Add' : 'Edit' }} single sign-on</component-title>
            <form-text
                :label="'Name'"
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-name'"
                :v-validate="{ required: true }"
                :required="true"
                :data-vv-as="'name'"
                v-model="subscriptionName"
            >This is the name that will appear when the user uses Single sign-on to login e.g - Login with Microsoft.
            </form-text>
            <component-title :size="'medium'">Subscription length</component-title>
            <form-date
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-from-date'"
                :label="'Start date'"
                :required="true"
                :v-validate="`required|date_format:yyyy-MM-dd|${subscriptionToDate ? `before:${subscriptionToDate}` : ``}`"
                :data-vv-as="'subscription start'"
                v-model="subscriptionFromDate"
            />
            <form-date
                :name="'lms-superadmin-customer-service-sso-edit-mel-setup-to-date'"
                :label="'End date'"
                :v-validate="`date_format:yyyy-MM-dd|${subscriptionFromDate ? `after:${validationRuleSubscriptionTo}` : ``}`"
                :data-vv-as="'subscription end'"
                v-model="subscriptionToDate"
            />
        </component-wrapper>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import FormText from '@/components/default/forms/FormText'
import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import FormDate from '@/components/default/forms/FormDate'

export default {
  name: 'lms-superadmin-customer-service-sso-edit-mel-setup',
  components: {
    ComponentWrapper,
    FormDate,
    ComponentTitle,
    FormText,
    PopNotify
  },
  data () {
    return {
      user: new User()
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    subscriptionName: {
      get () {
        return this.$store.getters.getEbsServiceSSOName
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetName', value)
      }
    },
    subscriptionFromDate: {
      get () {
        return this.$store.getters.getEbsServiceSSOFromDate
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetFromDate', value)
      }
    },
    subscriptionToDate: {
      get () {
        return this.$store.getters.getEbsServiceSSOToDate
      },
      set (value) {
        this.$store.dispatch('ebsServiceSSOSetToDate', value)
      }
    },
    isAddMode () {
      return this.$route.name.includes('service-sso-add')
    },
    isEditMode () {
      return this.$route.name.includes('service-sso-edit')
    },
    validationRuleSubscriptionTo () {
      const now = new Date()
      const subscriptionFrom = this.subscriptionFromDate
      const dateSubscriptionFrom = subscriptionFrom ? new Date(subscriptionFrom) : false
      if (subscriptionFrom && dateSubscriptionFrom < now) {
        return this.toISODateUTC(now)
      } else {
        return this.toISODateUTC(subscriptionFrom)
      }
    }
  },
  inject: ['$validator']
}
</script>
